import { ExprUtils } from '@/common/utils/ExprUtils';
import { MatchedDirSaleLines } from '@/sc/entities/dirSaleLine/MatchedDirSaleLines';
import { useMemo } from 'react';

/** The Direct Sale Lines the bucketing rolled into an Incentive Ledger Line. */
export const InctvLedgerLineSaleLineList = ({ inctvLedgerLineId }) => {
  const matchExpr = useMemo(() => ExprUtils.is('inctvLedgerLineId', inctvLedgerLineId), [inctvLedgerLineId]);

  if (!inctvLedgerLineId) return null;

  return <MatchedDirSaleLines matchExpr={matchExpr} />;
};
